import { statusMeta } from "@/lib/registry";

const TONES = {
  neutral: "bg-secondary text-muted-foreground border-border",
  muted: "bg-secondary/60 text-muted-foreground border-border",
  info: "bg-[hsl(232_85%_66%/0.15)] text-[hsl(232_90%_78%)] border-[hsl(232_85%_66%/0.3)]",
  success: "bg-[hsl(145_63%_42%/0.15)] text-[hsl(145_60%_60%)] border-[hsl(145_63%_42%/0.3)]",
  warning: "bg-[hsl(38_90%_50%/0.15)] text-[hsl(38_90%_62%)] border-[hsl(38_90%_50%/0.3)]",
  danger: "bg-[hsl(0_72%_56%/0.15)] text-[hsl(0_80%_72%)] border-[hsl(0_72%_56%/0.3)]",
  accent: "bg-accent/15 text-accent border-accent/30",
};

export function Badge({ tone = "neutral", children, className = "", testid }) {
  return (
    <span data-testid={testid}
      className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-medium border ${TONES[tone] || TONES.neutral} ${className}`}>
      {children}
    </span>
  );
}

export function StatusBadge({ entityType, status, testid }) {
  const meta = statusMeta(entityType, status);
  return <Badge tone={meta.tone} testid={testid || "status-badge"}>{meta.label}</Badge>;
}

const PRIO = { high: { tone: "danger", label: "Hög" }, medium: { tone: "warning", label: "Medel" }, low: { tone: "neutral", label: "Låg" } };
export function PriorityBadge({ priority, testid }) {
  const p = PRIO[priority] || PRIO.medium;
  return (
    <Badge tone={p.tone} testid={testid || "priority-badge"}>
      <span className="h-1.5 w-1.5 rounded-full bg-current" />{p.label}
    </Badge>
  );
}

export function Tag({ children }) {
  return <span className="inline-flex items-center px-2 py-0.5 rounded-md text-[0.7rem] font-medium bg-secondary text-muted-foreground border border-border">#{children}</span>;
}

export function TagList({ tags = [] }) {
  if (!tags.length) return null;
  return <div className="flex flex-wrap gap-1.5">{tags.map((t) => <Tag key={t}>{t}</Tag>)}</div>;
}

export function Avatar({ name = "?", size = 32, testid }) {
  const initials = name.split(" ").map((s) => s[0]).slice(0, 2).join("").toUpperCase();
  return (
    <span data-testid={testid}
      className="inline-grid place-items-center rounded-full bg-accent text-white font-semibold shrink-0"
      style={{ width: size, height: size, fontSize: size * 0.4 }}>
      {initials}
    </span>
  );
}

export function relTime(iso) {
  if (!iso) return "";
  const diff = (Date.now() - new Date(iso).getTime()) / 1000;
  if (diff < 0) return new Date(iso).toLocaleDateString("sv-SE", { day: "numeric", month: "short" });
  if (diff < 60) return "nyss";
  if (diff < 3600) return `${Math.floor(diff / 60)} min sedan`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} tim sedan`;
  return new Date(iso).toLocaleDateString("sv-SE", { day: "numeric", month: "short" });
}
